import { ArrowRight, Search } from 'lucide-react';
import { Button } from '@/components/ui/button';

export function SolutionsCTA() {
  return (
    <section className="py-20 md:py-28 bg-foreground">
      <div className="max-w-3xl mx-auto px-6 sm:px-8 lg:px-12 text-center">
        <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-white mb-5">
          Ready to protect your procedure revenue?
        </h2>
        <p className="text-gray-400 text-lg mb-10 leading-relaxed">
          See how LINK closes the gap between clinical intent and financial
          capture — with full compliance coverage.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button
            size="lg"
            className="bg-cta hover:bg-cta/90 text-cta-foreground font-bold px-8 rounded-md"
          >
            Request a System Audit
            <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
          <Button
            variant="outline"
            size="lg"
            className="border-gray-600 text-white hover:bg-white/10 font-semibold px-8 rounded-md"
          >
            <Search className="mr-2 h-4 w-4" />
            Explore Specialty Coverage
          </Button>
        </div>

        <p className="mt-4 text-xs text-gray-500">
          Ortho · Spine · GenSurg — and expanding
        </p>
      </div>
    </section>
  );
}
